export const logoSrcMap = {
  ED: "/images/onefront/bluestone/ED/prime_logo/ED-logo-prime-long.svg",
  OP: "/images/onefront/bluestone/OP/prime_logo/OP-logo-prime-long.svg",
  GO: "/images/onefront/bluestone/GV/prime_logo/GO-logo-prime-long.svg",
  TR: "/images/onefront/bluestone/TL/prime_logo/TL-logo-prime-long.svg",
};

export const INSIDE = "click";
export const CLOSE_BUTTON = "close_button";
export const GREEN_AREA = "green_area";
